export default "__VITE_ASSET__rGagxcQ7__"